import { createSignal, For, Show, useContext } from 'solid-js';
import { Heading } from '../../../ui-components/heading/heading';
import { Radio } from '../../../ui-components/inputs/radio/radio';
import { FilterIcon } from '../../icons-library/filter';
import { FilterList } from '../../../ui-components/filter-list/filter-list';
import { NestedCategory, ProductsProps } from '../products-types';
import { MobileCategoryTag } from './mobile-category-tag';
import { MobileFilterModal } from './mobile-filters-modal';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import decodeHtmlEntities from '../../../tools/decode-html-entities';

export const MobileProductsSidebar = (props: ProductsProps) => {
    const { localize } = useContext(AppContext);

    const [mobileFilterViewOpen, setMobileFilterViewOpen] = createSignal<boolean>(false);

    let filterListRef: HTMLDivElement | undefined;

    const openMobileFilterView = () => {
        setMobileFilterViewOpen(true);
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
    };

    const closeMobileFilterView = () => {
        setMobileFilterViewOpen(false);
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = '';
    };

    return (
        <>
            <FilterList
                isMobile={true}
                isDropdown={true}
                initialOpen={false}
                listHeading={props.store.store.areaOfCare?.name || props.labels?.topCategoryHeading}
                ref={filterListRef}
            >
                <For each={Object.keys(props.store.store.availableAreasOfCare)}>{(area) => (
                    <li>
                        <Radio
                            value={props.store.store.availableAreasOfCare[area]?._data?.slug}
                            whenClicked={() => {
                                props.clickHandlers.handleOnClickArea(area);
                                filterListRef?.click();
                            }}
                            name='areaOfCare'
                            readableName={decodeHtmlEntities(props.store.store.availableAreasOfCare[area]?._data?.name)}
                            isChecked={props.store.store.areaOfCare?.slug === props.store.store.availableAreasOfCare[area]?._data?.slug}
                        />
                    </li>
                )}</For>
            </FilterList>
            <Show when={props.store.store.availableProductCategories.length > 0}>
                <div class="px-6">
                    <button
                        class="flex justify-center items-center bg-transparent p-4 border border-gray rounded-small w-full"
                        onClick={openMobileFilterView}
                        aria-label={localize('open-filters', 'Open Filters')}
                    >
                        <div class="relative flex items-center">
                            <div class="absolute left-[-2.5rem] pr-4">
                                <FilterIcon ariaLabel={localize('open-submenu', 'Open submenu')} />
                            </div>
                            <Heading tag='h5' variant='medium' noBlockSpacing={true}>
                                {props.labels?.filtersHeading}
                            </Heading>
                        </div>
                    </button>
                </div>
            </Show>

            <Show when={props.store.store.areaOfCare}>
                <ul class="flex flex-wrap px-6 pt-6">
                    <MobileCategoryTag
                        category={props.store.store.areaOfCare?.name}
                        onClick={(e) => props.store.clearFilters(e)}
                    />
                    <For each={props.store.store.selectedProductCategories}>{(category: NestedCategory) => (
                        <MobileCategoryTag 
                            category={category._data.name} 
                            onClick={() => props.clickHandlers.handleOnClickCategory(category)}
                        />
                    )}</For>
                    <For each={props.store.store.selectedTypes}>{(type: NestedCategory) => (
                        <MobileCategoryTag
                            category={type._data.name}
                            onClick={() => props.clickHandlers.handleOnClickType(type)}
                        />
                    )}</For>
                </ul>
            </Show>

            <Show when={mobileFilterViewOpen()}>
                <MobileFilterModal
                    closeModal={closeMobileFilterView}
                    applyFiltersText={props.labels?.applyFiltersText || ''}
                    productCategoriesHeading={props.labels?.firstNestedCategoryHeading  || ''}
                    typesHeading={props.labels?.secondNestedCategoryHeading  || ''}
                    store={props.store}
                    clickHandlers={props.clickHandlers}
                />
            </Show>
        </>
    );
};
